import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import HostelPage from '../../views/HostelPage/';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';

const GLOBAL = require('../../Globals');

class Rooms extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			 idd : '',
			hlist : [],
			flist : [],
			hroomvancs : '',
			loading: false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			//value : '',
			alertClass :'',
			//_redirect : false,
			posts: []
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		//this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.vacchange = this.vacchange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
			this.getdata();
	}
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	vacchange(e){
		this.state.hroomvancs = e.target.value;
	}
	
	
	onClick(e){
		
		document.getElementById("roomform").reset();
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('hostel/removeroom',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Room Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Room',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onBack(){
		
		this.setState({idd : ''});
		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.getrmdata();
		
	}
	
	getrmdata(){
		
		GetData('hostel/getroombyid/'+this.state.idd).then((result) => {
			let res = result;
			if(res){
				this.setState({
					hname : res[0]['hostel'],
					hfloor : res[0]['floor'],
					hroomname : res[0]['name'],
					hrtype : res[0]['type'],
					hroomvancs : res[0]['vacancies'],
					hroomfee : res[0]['fee'],
					hrft : res[0]['features']
				});
				this.getfloors();
			}
		});
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state.idd){
			PostData('hostel/updateroom',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Room Updated Successfully!..',
						alertClass:'alert alert-success',
						idd : ''
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
				$("#showLoader").hide();
			});
		}
	
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state!=''){
			PostData('hostel/addroom',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Room Added Successfully!..',
						alertClass:'alert alert-success'
					});
					document.getElementById("roomform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("roomform").reset();
					this.getdata();
				}
				$("#showLoader").hide();
			});
		
		}
	
	}
	
	componentWillMount() {
		 
		this.getdata();
		this.gethostel();
		
	}
	
	/** get  Hostel List **/
	gethostel(){
		
		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					hlist : responseJson
				});
				this.getdata();
			}
		});
	}
	
	
	/** get  Floor List **/
	getfloors(){
		
		GetData('hostel/getfloorbyhostelid/'+this.state.hname).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					flist : responseJson
				});
			}
		});
	}
	
	
	getdata(){
		this.setState({loading:true});
		GetData('hostel/getrooms').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					loading:false
				});
			}
		});
	}
	
	
  render() {
	  
	$("#hname").change(function(){
	
			var host = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getfloorbyhostelid/'+host,function(o){
				$("#hfloor").html('');
				$('#hfloor')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Floor- ')); 
				$.each(o,function(key,value){			
					   $('#hfloor')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
		
		});
		
	$("#hnameup").change(function(){
	
			var host = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getfloorbyhostelid/'+host,function(o){
				$("#hfloorup").html('');
				$('#hfloorup')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Floor- ')); 
				$.each(o,function(key,value){			
					   $('#hfloorup')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
		
		});
		
	
	var hnames = this.state.hlist;
	var fnames = this.state.flist;
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	/** set status select box **/
	this.roomtype = [
		{value : '', name : 'Select'},
		{value : 'single', name : 'Single'},
		{value : 'fourbed', name : 'Four Bed'},
		{value : 'ac', name : 'AC'},
		{value : 'delux', name : 'Delux'}
	];
	
	if(this.state.idd!=''){
		
		$("#editrm").show();
		$("#addrm").hide();
	}
	else{
		
		$("#editrm").hide();
		$("#addrm").show();
	}
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item}>
							<td width="20">{i+1}</td>
							<td>{item.hname}</td>
							<td>{item.fname}</td>
							<td>{item.name}</td>
							<td>{item.type}</td>
							<td>
								<button name="edithw" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
								&nbsp;&nbsp;
								<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
							</td>
					 </tr>;
	});
	
    return (
		<div>
		  <HostelPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5" id="addrm">
					<Card>
					  <form action="" method="post" role="form" id="roomform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Room</strong>
							
						</CardHeader>
						<CardBody>
							<Row>
							 <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Hostel<span className="text-danger">*</span></Label>
								  <select name="hname" className="form-control"  onChange={this.onChange} required id="hname">
										<option value="">Select Hostel</option>
										{
											hnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								</select>
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Floor<span className="text-danger">*</span></Label>
								   <select name="hfloor" onChange={this.onChange} className="form-control" id="hfloor" required> 
									
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">No<span className="text-danger">*</span></Label>
								  <Input type="text" name="hroomname" required onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Type<span className="text-danger"></span></Label>
								   <select name="hrtype" onChange={this.onChange} className="form-control" > 
									{this.roomtype.map((e, key) => {
													return <option key={key} value={e.value}>{e.name}</option>;
												})}	
								  </select>
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Vacancies<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomvancs" required onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Fee<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomfee" required onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Features<span className="text-danger"></span></Label>
								  <Input type="textarea" name="hrft" placeholder="Seperated By comma(,)" rows="5" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="5" id="editrm">
					<Card>
					  <form action="" method="post" role="form" id="flrupform" encType="multipart/form-data" onSubmit={this.onupdateSubmit} >
						<CardHeader>
							<strong>Update Room</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							 <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Hostel<span className="text-danger">*</span></Label>
								  <select name="hname" className="form-control"  onChange={this.onChange} value={this.state.hname} required id="hnameup">
										<option value="">Select Hostel</option>
										{
											hnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								</select>
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Floor<span className="text-danger">*</span></Label>
								   <select name="hfloor" onChange={this.onChange} className="form-control" value={this.state.hfloor} id="hfloorup" required> 
									<option value="">Select Floor</option>
										{
											fnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Name<span className="text-danger">*</span></Label>
								  <Input type="text" name="hroomname" required onChange={this.onChange} value={this.state.hroomname} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Type<span className="text-danger"></span></Label>
								   <select name="hrtype" onChange={this.onChange} className="form-control" value={this.state.hrtype} > 
									{this.roomtype.map((e, key) => {
													return <option key={key} value={e.value}>{e.name}</option>;
												})}	
								  </select>
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Vacancies<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomvancs" required onChange={this.onChange}  value={this.state.hroomvancs} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Fee<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomfee" required onChange={this.onChange}  value={this.state.hroomfee} required />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Features<span className="text-danger"></span></Label>
								  <Input type="textarea" name="hrft" placeholder="Seperated By comma(,)" rows="5" value={this.state.hrft} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				   <Col md="7">
				   <Card>
				   <CardHeader>
							<strong>Rooms</strong>
						</CardHeader>
					<CardBody>
					<Col md="12">
					<Table responsive bordered>
						<thead>
							<tr>
								<th width="20">S.No</th>
								<th>Hostel Name</th>
								<th>Floor Name</th>
								<th>Room No</th>
								<th>Type</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.loading ?  <tr><td colSpan="6"><center><Loader /></center></td></tr> : renderTodos}
						</tbody>
					</Table>
					</Col>
					<Col md="4">
					  <Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.posts.length}
								 onChange={this.handlePageChange}
								/>
					  </Col>
					  <Col md="2">
					   <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					  </Col>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Rooms;


// WEBPACK FOOTER //
// ./src/hostel/HostelList/rooms.js